/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'mag': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<g _fill="none" fill-rule="evenodd" _stroke="#212121" stroke-width="2"><circle pid="0" cx="10" cy="8" r="5"/><path pid="1" d="M15.5 17.5l-3-5" stroke-linecap="round" stroke-linejoin="round"/></g>'
  }
})
